module.exports = __webpack_public_path__ + "img/jacobsen_Portrett1.bcaf6506.jpg";